  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('video.product-video').forEach(function (video) {
      video.muted = true;
      video.play().catch(function (e) {
        // Autoplay blocked - user interaction var try karo
        document.addEventListener('click', function () {
          video.play();
        }, { once: true });
      });
    });
  });
